import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../../theme';
import { FA_SELECTOR } from '../../../styles/variables';

export const useSaveTemplatePopupStyles = createStyles(() => ({
  overlay: {
    width: 280,

    '> .ant-popover-content > .ant-popover-inner': {
      boxShadow: `0 0 35px ${ThemeColors.COLOR_GREY6}`,
      backgroundColor: ThemeColors.COLOR_WHITE3,
    },

    '.ant-popover-inner-content': {
      padding: `${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px`,
    },

    'h4.ant-typography': {
      fontWeight: 400,
      marginBottom: ThemeSpaces.SPACE_NORM,
    },
  },
  controlButtons: {
    '> .ant-col': {
      lineHeight: '16px',
    },

    '.InlineLink': {
      color: ThemeColors.COLOR_RED,
      fontWeight: 500,

      '&.cancel-button': {
        // Firefox renders in a buggy way if a parent has underline and a child contains text
        '> *': {
          textDecoration: 'underline',
        },
      },

      [FA_SELECTOR]: {
        marginRight: ThemeSpaces.SPACE_XS,
      },
    },
  },
}));
